import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ExportStatistics, OngoingStatisticExportFiles } from '../../../../models/backend/statistics/export-statistics';
import { ThingType } from '../../../../models/thingtype';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  private readonly backendUrl = environment.backendUrl;

  constructor(private readonly http: HttpClient) {}

  getExportFileUrl(thingType: ThingType, key: string): Observable<ExportStatistics> {
    return this.http.get<ExportStatistics>(`${this.backendUrl}/statistics/exports/file`, {
      params: {
        thingType,
        key,
      },
    });
  }

  startManualExport(thingType: ThingType): Observable<void> {
    return this.http.post<void>(
      `${this.backendUrl}/statistics/exports`,
      {},
      {
        params: {
          thingType,
        },
      },
    );
  }

  listExports(thingType: ThingType): Observable<OngoingStatisticExportFiles> {
    return this.http.get<OngoingStatisticExportFiles>(`${this.backendUrl}/statistics/exports`, {
      params: { thingType },
    });
  }
}
